import React from "react";
import { CalendarDays, Sparkles } from "lucide-react";

interface MerchantHomeWelcomeSectionProps {
  userName: string;
  currentDate: string;
}

export const MerchantHomeWelcomeSection: React.FC<MerchantHomeWelcomeSectionProps> = ({
  userName,
  currentDate,
}) => (
  <section className="flex flex-1 self-stretch flex-col justify-between gap-8 rounded-2xl bg-white p-6 outline outline-1 outline-offset-[-1px] outline-gray-200 dark:bg-gray-800 dark:outline-gray-700">
    <div>
      <div className="mb-5 flex h-10 w-10 items-center justify-center rounded-full bg-[#e8faf5] text-[#00a982] dark:bg-emerald-900/30 dark:text-emerald-400">
        <Sparkles className="h-5 w-5" aria-hidden="true" />
      </div>
      <p className="text-sm font-semibold uppercase tracking-[0.12em] text-[#00a982] dark:text-emerald-400">
        Welcome back
      </p>
      <h2 className="mt-2 text-2xl font-semibold leading-8 text-[#004232] dark:text-white">
        {userName}
      </h2>
      <p className="mt-3 max-w-md text-sm leading-6 text-gray-500 dark:text-gray-400">
        Keep your events and coupons ready for your customers today.
      </p>
    </div>
    <div className="flex items-center gap-2 text-sm font-medium text-gray-500 dark:text-gray-400">
      <CalendarDays className="h-4 w-4 text-[#00a982] dark:text-emerald-400" aria-hidden="true" />
      {currentDate}
    </div>
  </section>
);
